import {
  RematchDispatch,
  RematchRootState,
  Models,
  init,
} from '@wmfe/mach-pro-store';
import { global } from './global';
import { filterBarHandleModel } from './filterBarHandleModel';

export interface RootModel extends Models<RootModel> {
  global: typeof global;
}

export type Dispatch = RematchDispatch<RootModel>;
export type RootState = RematchRootState<RootModel, any>;
// 初始化
init({ models: { global, filterBarHandleModel } });
